<div class="header">
    <h2>{{ 'admins.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="admins-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'admins.error.unavailable' | translate" />
} @else if (admin(); as admin) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ admin.firstName }} {{ admin.lastName }}</h1>
                <span class="subtitle">{{ admin.email }}</span>
            </div>
        </div>

        <div class="meta-strip">
            <div class="meta-item">
                <span class="meta-label">{{ 'admins.form.createdAt' | translate }}</span>
                <span class="meta-value">{{ admin.createdAt | date: 'mediumDate' }}</span>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-delete-button [adminId]="admin.id" [saving]="saving()" testId="admins-view-delete" />
        <p-button [label]="'admins.detail.edit' | translate" icon="pi pi-pencil" data-test="admins-view-edit" (onClick)="onEdit()" />
    </div>
}
